module.exports = __webpack_public_path__ + "img/title3.a1faa44c.svg";